import { Trash2, Search, MessagesSquare, MapPin, ChevronRight } from "lucide-react";

const CARDS = [
  {
    label: "Request", icon: Trash2,
    body: (
      <>
        <p className="font-display font-extrabold text-[var(--b2-navy)] text-lg leading-tight">Junk Removal</p>
        <p className="text-sm text-[var(--b2-ink-soft)] mt-1 inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> Plainfield, IL</p>
      </>
    ),
  },
  {
    label: "Finding pros", icon: Search,
    body: (
      <>
        <p className="font-display font-extrabold text-[var(--b2-navy)] text-lg leading-tight">Local professionals contacted</p>
        <span className="mt-2 inline-flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-[var(--b2-green)] animate-pulse" />
          <span className="w-2 h-2 rounded-full bg-[var(--b2-green)]/60 animate-pulse [animation-delay:150ms]" />
          <span className="w-2 h-2 rounded-full bg-[var(--b2-green)]/30 animate-pulse [animation-delay:300ms]" />
        </span>
      </>
    ),
  },
  {
    label: "Responses", icon: MessagesSquare,
    body: (
      <>
        <p className="font-display font-extrabold text-[var(--b2-navy)] text-lg leading-tight">2 responses received</p>
        <p className="text-sm text-[var(--b2-ink-soft)] mt-1">Compare and choose who you want.</p>
      </>
    ),
  },
];

// Illustrative product moment — example interface only, no live data claims.
export const HomeProductPreview = () => (
  <section className="py-14 md:py-24 bg-white" data-testid="home-product-preview">
    <div className="max-w-[1300px] mx-auto px-5 md:px-10">
      <div className="text-center max-w-xl mx-auto mb-11 md:mb-14">
        <h2 className="font-display text-[32px] md:text-[44px] font-extrabold tracking-[-0.02em] leading-[1.08] text-[var(--b2-navy)]">
          One request.<span className="block text-[var(--b2-green)]">Multiple local options.</span>
        </h2>
      </div>
      <div className="grid md:grid-cols-[1fr_auto_1fr_auto_1fr] gap-4 md:gap-3 items-stretch max-w-4xl mx-auto">
        {CARDS.map((c, i) => (
          <div key={c.label} className="contents">
            <div data-testid={`preview-card-${i}`}
              className="bg-white rounded-[24px] border border-[var(--b2-border)] shadow-[0_20px_50px_rgba(10,21,48,0.10)] p-6 flex flex-col">
              <span className="inline-flex items-center gap-2 self-start rounded-full bg-[var(--b2-green-soft)] text-[#166534] text-[11px] font-extrabold uppercase tracking-[0.12em] px-3 py-1.5 mb-4">
                <c.icon className="w-3.5 h-3.5" /> {c.label}
              </span>
              {c.body}
            </div>
            {i < CARDS.length - 1 && (
              <div className="hidden md:flex items-center justify-center">
                <ChevronRight className="w-7 h-7 text-[var(--b2-green)]" strokeWidth={2.5} />
              </div>
            )}
          </div>
        ))}
      </div>
      <p className="mt-6 text-center text-xs uppercase tracking-wider text-[#94A3B8] font-semibold" data-testid="preview-disclaimer">Illustrative example of the Brivio experience</p>
    </div>
  </section>
);
